import React from "react";
import { UICheckbox } from "components/ui";
import MobileStateTaxIDTableRow from "../MobileStateTaxIDTableRow";

import "./styles.css";

/**
 * @function MobileStateTaxIDTable
 * @return {React.Component}
 * @exported true
 * @description This is the state tax ID mobile main table view
 */
export default function MobileStateTaxIDTable(props) {
    const stateTaxIDs = props.stateTaxIDs ?? [];
    const onDenyAllClick = props.onDenyAllClick ?? undefined;
    const onRowClick = props.onRowClick ?? undefined;
    const allRowsCheckboxIsSelected = props.allRowsCheckboxIsSelected === true;

    const rows = stateTaxIDs.reduce((acc, item) => {
      acc.push(
        <MobileStateTaxIDTableRow key={ item.id } company={ item.company.name } state={ item.state }
        taxId={ item.taxID } stateTaxID={ item } onRowClick={ onRowClick } isSelected={ item.isSelected } />
      );
      return acc;
    }, []);
    
    return (
        <div className="mobile-state-tax-id-table">
            <MobileStateTaxIDTableHeader onDenyAllClick={ onDenyAllClick } allRowsCheckboxIsSelected={ allRowsCheckboxIsSelected } />
            { rows }
        </div>
    );
}

/**
* @function MobileStateTaxIDTableHeader
* @return {React.Component}
* @exported false
* @description This is the mobile table header used for MobileStateTaxIDTable component.
*/
function MobileStateTaxIDTableHeader(props) {
    const onDenyAllClick = props.onDenyAllClick ?? undefined;
    const allRowsCheckboxIsSelected = props.allRowsCheckboxIsSelected === true;
    
    return (
        <div className="mobile-state-tax-id-table-header">
            <div className="table-header-container flex-container flex-horizontal">
                <div className="set-width state-id-checkbox">
                    <UICheckbox label="" value={ allRowsCheckboxIsSelected } onChange={ onDenyAllClick } />
                </div>
            </div>
        </div>
    );
}
